function getImg(fabric, url) {
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(url, img => {
      resolve(img)
    },
    {
      crossOrigin: 'anonymous'
    }
    )
  })
}
/**
 * 图片笔刷
 * @param {*} fabric
 * @param {*} canvas
 * @returns
 */
export default function(fabric, canvas, options = {}) {
  return new fabric.DiagramBrush(canvas, {
    ...options,
    async getObject(opt, pointer) {
      const { url, name } = options
      const objectImg = await getImg(fabric, url)
      // 如果图片为非 svg 可先缩小，以防放大时候变虚
      const scale = options.scale || 1
      const { width, height } = objectImg
      const left = pointer.x - (width * scale) / 2
      const top = pointer.y - (height * scale) / 2
      objectImg.scale(scale).set({
        name,
        left: left < 0 ? 0 : left,
        top: top < 0 ? 0 : top
      })
      return objectImg
    },
    renderMove(opt, pointer) {
      //
    }
  })
}